import { Moon, Sun } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useTheme } from '@/hooks/useTheme';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const reduceMotion = useReducedMotion();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="relative grid size-11 shrink-0 cursor-pointer place-items-center rounded-[var(--radius-sm)] border border-border bg-surface text-text-primary transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Uključi svetlu temu' : 'Uključi tamnu temu'}
      title={isDark ? 'Svetla tema' : 'Tamna tema'}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={
            reduceMotion ? false : { opacity: 0, rotate: -35, scale: 0.7 }
          }
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={
            reduceMotion ? undefined : { opacity: 0, rotate: 35, scale: 0.7 }
          }
          transition={{ duration: 0.18 }}
        >
          {isDark ? (
            <Sun aria-hidden="true" className="size-4.5" />
          ) : (
            <Moon aria-hidden="true" className="size-4.5" />
          )}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
